/**
 * Standardized service result type for all Supabase operations.
 */
export type ServiceResult<T> =
  | { data: T; error: null }
  | { data: null; error: ServiceError };

/**
 * Structured error object with user-friendly message and optional debug details.
 */
export interface ServiceError {
  message: string;
  details?: string;
  code?: string;
}

/**
 * Creates a ServiceError with optional dev-mode details.
 */
export function createError(
  message: string,
  details?: string,
  code?: string
): ServiceError {
  const error: ServiceError = { message };
  
  if (import.meta.env.DEV && details) {
    error.details = details;
  }
  
  if (code) {
    error.code = code;
  }
  
  return error;
}

export function isServiceError<T>(
  result: ServiceResult<T>
): result is { data: null; error: ServiceError } {
  return result.error !== null;
}

export function isServiceSuccess<T>(
  result: ServiceResult<T>
): result is { data: T; error: null } {
  return result.error === null;
}


